export default [
  {
    path: 'posts',
    component: () => import('@/layouts/GroupLayout'),
    children: [
      {
        path: ':id',
        component: () => import('@/pages/posts/Show'),
        name: 'posts.index',
        props: true,
      },
    ],
  },
];
